var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHouseholdIllustration = function SvgHouseholdIllustration(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 324,
    height: 250,
    fill: "none",
    viewBox: "0 0 324 250"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#HouseholdIllustration_svg__a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#HouseholdIllustration_svg__b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 292,
    height: 220,
    x: 21.957,
    y: 8.51,
    fill: "url(#HouseholdIllustration_svg__c)",
    rx: 1.737,
    shapeRendering: "crispEdges",
    transform: "rotate(3 21.957 8.51)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    fill: "url(#HouseholdIllustration_svg__d)",
    fillOpacity: 0.56,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 291,
    height: 219,
    x: 16.5,
    y: 15.5,
    stroke: "url(#HouseholdIllustration_svg__e)",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 4,
    x: 40,
    y: 39,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 4,
    x: 40,
    y: 47,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 76,
    x: 208,
    y: 103,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 120,
    x: 228,
    y: 59,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 140,
    x: 248,
    y: 39,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 132,
    x: 268,
    y: 47,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 56,
    x: 208,
    y: 123,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 80,
    x: 228,
    y: 99,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 140,
    x: 248,
    y: 39,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 120,
    x: 268,
    y: 59,
    fill: "#8598AF",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 76,
    height: 16,
    x: 208,
    y: 195,
    fill: "#516B89",
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 144,
    x: 40,
    y: 67,
    fill: "#516B89",
    fillOpacity: 0.4,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#8598AF",
    strokeWidth: 0.5,
    d: "M116 112v20a4 4 0 0 1-4 4H72a4 4 0 0 0-4 4v13M116 112v20a4 4 0 0 0 4 4h40a4 4 0 0 1 4 4v13M116 112v41M104 112h24"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 80,
    y: 100,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M96 116.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.698 0-1.047 0-1.33.086a2 2 0 0 0-1.334 1.333c-.086.284-.086.633-.086 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 128.021,
    y: 100,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M144.021 116.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.697 0-1.046 0-1.33.086a2 2 0 0 0-1.333 1.333c-.087.284-.087.633-.087 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 56,
    y: 153,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M72 169.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.698 0-1.047 0-1.33.086a2 2 0 0 0-1.334 1.333c-.086.284-.086.633-.086 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 104,
    y: 153,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M120 169.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.698 0-1.047 0-1.331.086a2 2 0 0 0-1.333 1.333c-.086.284-.086.633-.086 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    x: 152,
    y: 153,
    fill: "#8598AF",
    rx: 12
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.667,
    d: "M168 169.5c0-.698 0-1.047-.086-1.331a2 2 0 0 0-1.333-1.333c-.284-.086-.633-.086-1.331-.086h-2.5c-.698 0-1.047 0-1.331.086a2 2 0 0 0-1.333 1.333c-.086.284-.086.633-.086 1.331m6.25-6.75a2.25 2.25 0 1 1-4.5 0 2.25 2.25 0 0 1 4.5 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "HouseholdIllustration_svg__c",
    x1: 27.962,
    x2: 150.169,
    y1: 12.861,
    y2: 298.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#111827",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111827",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HouseholdIllustration_svg__d",
    x1: 19.681,
    x2: 150.959,
    y1: 16.212,
    y2: 306.511,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#385677"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "HouseholdIllustration_svg__e",
    x1: 275,
    x2: 209.219,
    y1: 235,
    y2: 71.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#516B89"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#516B89",
    stopOpacity: 0.56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "HouseholdIllustration_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h324v250H0z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "HouseholdIllustration_svg__b",
    width: 448.99,
    height: 380.857,
    x: -62.495,
    y: -64.429,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 8.683,
    result: "effect1_dropShadow_7_4262"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -7.815,
    dy: 10.42
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.645
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.00392157 0 0 0 0 0.0431373 0 0 0 0 0.145098 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7_4262"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7_4262",
    result: "shape"
  })))));
};
export default SvgHouseholdIllustration;